const DEFAULT_PUBLIC_SITE_URL = 'https://updates.ncof.tv';

const normalizeBaseUrl = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    return new URL(withProtocol).origin;
  } catch {
    return '';
  }
};

export function getPublicSiteBaseUrl() {
  const configured =
    process.env.REACT_APP_PUBLIC_SITE_URL ??
    process.env.REACT_APP_WEBSITE_URL ??
    '';

  return normalizeBaseUrl(configured) || DEFAULT_PUBLIC_SITE_URL;
}

export function buildPublicFacilityBookingUrl(token?: string | null) {
  const url = new URL('/facility-booking', `${getPublicSiteBaseUrl().replace(/\/$/, '')}/`);
  if (token) {
    url.searchParams.set('facilityHandoff', token);
  }
  return url.toString();
}
